import { Spin } from 'antd'
import { PropsWithChildren } from 'react'

interface SpinnerProp {
  spinning: boolean
}
const Spinner = ({ children, spinning }: PropsWithChildren<SpinnerProp>) => {
  return (
    <Spin
      spinning={spinning}
      className='!z-[9999] bg-[#00000059] !max-h-screen'
    >
      {children}
    </Spin>
  )
}

export default Spinner
